export const clientDetection = (): string => {
    const url: URL = new URL(globalThis.location.href);
    const state: string = url.hostname.split(/[-.]/)[0];

    if (state === 'localhost') {
        return 'NY';
    }

    return state.toUpperCase();
};

export function encodeBase64(input: string): string {
    return btoa(input);
}
